import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";

import { MatDialog } from "@angular/material/dialog";
import {
  MatPaginator,
  MatPaginatorIntl,
  PageEvent,
} from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { SessionsService } from "src/app/services/session/sessions.service";

import { SesionDetailsComponent } from "../../components/sesion-details/sesion-details.component";
import {
  EnumAssistanceStatus,
  IAttendant,
  IEventAndSessionData,
  IReporteAsistenciaSession,
  ISession,
  ISetGradeObj,
} from "../../interfaces/reports.interfaces";

import * as XLSX from "xlsx";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { ICourseSession } from "src/app/attendanceRecord/interfaces/SessionsInterface";
import { ModalSharedServiceService } from "src/app/shared/modals/modal-service.service";
import { ResponseDataInterfaces } from "src/app/models/Interfaces/ResponseDataInterfaces";
import { AssistanceService } from "src/app/attendanceRecord/services/asistanceService/assistance.service";
import { CatalogService } from "src/app/catalog/services/catalog.service";
import {
  ICalendarCatalog,
  ICatalogItem,
} from "src/app/catalog/interfaces/catalog.interface";
import { from, Subject, switchMap, take, takeUntil } from "rxjs";
import { GeneralEmptyModalComponent } from "src/app/shared/modals/general-empty-modal/general-empty-modal.component";
import { ModalConfig } from "src/app/shared/modals/modal.interfaces";
import { formatDate } from "@angular/common";
import { IOffCanvasOptions } from "src/app/shared/off-canvas/off-canvas.interface";
import { OffCanvasComponent } from "src/app/shared/off-canvas/off-canvas.component";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { originDataEnumEmailPerAd } from "src/app/attendanceRecord/constants/idOriginAsistance";
import { MatTabChangeEvent } from "@angular/material/tabs";

@Component({
  selector: "app-reports-page",
  templateUrl: "./reports-page.component.html",
  styleUrls: ["./reports-page.component.css"],
})
export class ReportsPageComponent implements OnInit, OnDestroy {
  /**Datos de entrada desde la tabla, Visualizar Detalle del Usuario */
  selectedPageSize: number = 5;
  currentPage: number = 1;
  totalRecords: number = 0;
  searchText: string = '';
  attendancesList!: any[];
  dataSource: MatTableDataSource<IAttendant> = new MatTableDataSource();
  displayedColumns: string[] = [
    "code",
    "name",
    "curp",
    "email",
    "date",
    "numeroSesion",
    "status",
    "delete",
  ];

  coursesSessions: ICourseSession[] = new Array();
  selectedCourseSession?: ICourseSession;
  sessions: ISession[] = new Array();
  selectedSession: number = -1; // -1 is used for getting assitance for all the sessions
  reporteAsistenciasSessions: IReporteAsistenciaSession | null = null;
  unAlteredAttendants: IAttendant[] = [];

  // flags
  isLoadingSessions: boolean = false;
  detailSessionButton: boolean = true;
  isQueueAssistancesLoading: boolean = false;
  spinner: boolean = false;
  showSelectCourseError: boolean = false;
  isAssistanceLoading: boolean = false;
  showGradeColumn: boolean = false;
  gradesTouched: boolean = false;
  showsAllSessionsAttendance: boolean = false;
  errorOnGetAttendance: boolean = false;
  isLoadingGrades: boolean = false;
  isLoadingDuplicateAttendance: boolean = false;
  isModalOpen: boolean = false;
  isDuplicateAttendanceModalOpen: boolean = false;
  isAttendanceModalOpen: boolean = false;

  deletingAttendant: number | null = null;
  gettingAttendantDetails: IAttendant | null = null;

  // tabs
  selectedTab: "my" | "shared" = "my";

  // year filter
  selectedYear?: number;
  // catalogs
  yearList: ICalendarCatalog[] = [];
  justificationList: ICatalogItem[] = [];

  private unsubscribe$ = new Subject<void>();

  // offcanvas
  @ViewChild("offcanvasAttendanceComponent")
  offcanvasComponent!: OffCanvasComponent;
  protected offCanvasOptions: IOffCanvasOptions = {
    title: "Detalles de asistencia",
    ngbOptions: {
      keyboard: true,
      position: "end",
      beforeDismiss: () => {
        this.gettingAttendantDetails = null;
        this.offCanvasOptions.title = "Detalles de asistencia";
        return true;
      },
    },
  };

  // duplicateAttendanceModal
  @ViewChild("modalDuplicateAttendance")
  public duplicateAttendanceModal!: GeneralEmptyModalComponent;
  public duplicateAttendanceModalConfig: ModalConfig = {
    modalTitle: "Duplicación de asistencias",
    hideCloseButton: true,
    hideDismissButton: true,
    ngModalOptions: {
      centered: true,
      size: "lg",
      backdrop: "static",
    },
  };

  // modal attendance register
  @ViewChild("modal")
  public modalComponent!: GeneralEmptyModalComponent;
  private basicModalTitle = "Registro de asistencias";
  public modalConfig: ModalConfig = {
    modalTitle: this.basicModalTitle,
    hideCloseButton: true,
    hideDismissButton: true,
    ngModalOptions: {
      centered: true,
      size: "lg",
      backdrop: "static",
    },
  };

  // // modal new attendant
  private modalRef?: NgbModalRef;

  @ViewChild(MatPaginator) paginatorSet!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private sessionsService: SessionsService,
    private assistanceService: AssistanceService,
    private catalogService: CatalogService,
    private dialog: MatDialog,
    private authService: AuthenticationService,
    private paginator: MatPaginatorIntl,
    private sharedModalService: ModalSharedServiceService,
    public modal: NgbModal
  ) {
    this.paginator.itemsPerPageLabel = "Registros por página";
  }

  ngOnInit(): void {
    this.getCatalogYears();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get getOgAttendantsHaveGrades() {
    if (!this.unAlteredAttendants) {
      return false;
    }
    return this.unAlteredAttendants.some(
      ({ calificacion }) => calificacion !== undefined && calificacion !== null
    );
  }

  get getIsExcelBtnDisabled() {
    return (
      this.isAssistanceLoading ||
      !this.reporteAsistenciasSessions ||
      this.reporteAsistenciasSessions.participantes.length === 0
    );
  }

  get isAddAttendantBtnDisabled(): boolean {
    return (
      this.isAssistanceLoading ||
      !this.reporteAsistenciasSessions ||
      !this.reporteAsistenciasSessions.masDelNoventaDeAssistencias
    );
  }

  get eventAndSessionData(): IEventAndSessionData | undefined {
    if (!this.selectedCourseSession || !this.selectedYear) {
      return undefined;
    }
    return {
      eventName: this.selectedCourseSession.nombreEvento,
      locatorId: this.selectedCourseSession.IdLocalizador,
      sessionName: this.selectedCourseSession.titulo,
      fkObjectIdExt: this.selectedCourseSession.fkObjectIdExt,
      yearId: this.selectedYear,
    };
  }

  get enableActionBtns(): boolean {
    return (
      !!this.selectedCourseSession &&
      (this.reporteAsistenciasSessions?.participantes?.length ?? 0) > 0
    );
  }

  getFullName(attendant: IAttendant, lastNameFirst: boolean = false) {
    const firstNames = [attendant.nombre ?? "", attendant.segundoNombre ?? ""];

    const lastNames = [
      attendant.apellidoPaterno ?? "",
      attendant.apellidoMaterno ?? "",
    ];

    return lastNameFirst
      ? `${lastNames.join(" ").trim()} ${firstNames.join(" ").trim()}`.trim()
      : `${firstNames.join(" ").trim()} ${lastNames.join(" ").trim()}`.trim();
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedTab = event.index === 0 ? "my" : "shared";
    this.getSessionsListBySelectedYear();
  }

  private getCatalogYears() {
    this.spinner = true;

    from(this.catalogService.getCatalogList("year"))
      .pipe(
        switchMap(() => this.catalogService.yearCatalogList.pipe(take(1))),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: l => {
          const currentYear = l.find(
            a => a.nombre === new Date().getFullYear().toString()
          );

          this.yearList = l;
          this.selectedYear = currentYear?.id;

          if (this.selectedYear) {
            this.loadCoursesSessions(this.selectedYear);
          }

          this.spinner = false;
        },
        error: e => {
          console.error("Error", e);
          this.spinner = false;
        },
      });
  }

  getSessionsListBySelectedYear() {
    if (!this.selectedYear) {
      return;
    }
    this.selectedCourseSession = undefined;
    this.onBlurCourseSelect();
    if (this.selectedTab === "my") {
      this.loadCoursesSessions(this.selectedYear);
    } else {
      this.loadSharedCoursesSessions(this.selectedYear);
    }
    this.reporteAsistenciasSessions = null;
    this.unAlteredAttendants = structuredClone([]);
    this.initMatTableData([]);
  }

  onChangeYearWrapper(yearId: number): void {
    this.selectedYear = yearId;
    this.getSessionsListBySelectedYear();
  }

  onSessionChangeWrapper(sessionId: number | null): void {
    if (!sessionId) {
      this.selectedCourseSession = undefined;
      return;
    }

    this.selectedCourseSession = this.coursesSessions.find(
      s => s.Id === sessionId
    );
    this.reporteAsistenciasSessions = null;
    this.unAlteredAttendants = structuredClone([]);
    this.initMatTableData([]);

    this.loadSessions({ value: sessionId });
  }

  loadCoursesSessions(yearId: number) {
    const userId = this.authService.currentUserValue.id;
    this.isLoadingSessions = true;
    this.sessionsService
      .getCoursesSessionsByUserId(userId, { yearId })
      .subscribe({
        next: ({ data }) => {
          this.coursesSessions = data;
          this.isLoadingSessions = false;
        },
        error: () => {
          this.coursesSessions = [];
          this.isLoadingSessions = false;
        },
      });
  }

  loadSharedCoursesSessions(yearId: number) {
    const userId = this.authService.currentUserValue.id;
    this.isLoadingSessions = true;
    this.sessionsService
      .getSharedCoursesSessionsByUserId(userId, { yearId })
      .subscribe({
        next: ({ data }) => {
          this.coursesSessions = data;
          this.isLoadingSessions = false;
        },
        error: () => {
          this.coursesSessions = [];
          this.isLoadingSessions = false;
        },
      });
  }

  loadSessions(event: any) {
    this.sessions = new Array();
    const numeroSesiones: number = this.getSelectedItem(event.value);
    for (let i = 0; i < numeroSesiones; i++) {
      this.sessions.push({ value: i + 1, showValue: i + 1 });
    }
    this.showSelectCourseError = false;
  }

  getSelectedItem(id: any): number {
    for (const courseSession of this.coursesSessions) {
      if (courseSession.Id === id) {
        this.selectedCourseSession = courseSession;
        this.detailSessionButton = false;
        return this.selectedCourseSession?.TotalPartes || 0;
      }
    }
    return 0;
  }

  loadReport() {
    const id = this.selectedCourseSession?.Id;
    if (!id) {
      return;
    }
    this.isAssistanceLoading = true;
    const getReportObservable =
      this.selectedSession === -1 // -1 is used for getting assitance for all the sessions
        ? this.sessionsService.getReporteAsistenciaSession(id, undefined, this.currentPage, this.selectedPageSize, this.searchText)
        : this.sessionsService.getReporteAsistenciaSession(id, this.selectedSession, this.currentPage, this.selectedPageSize, this.searchText);

    getReportObservable.subscribe({
      next: response => {
        this.totalRecords = response.totalRecords
        this.reporteAsistenciasSessions = response;
        this.unAlteredAttendants = structuredClone(response.participantes);
        this.showsAllSessionsAttendance = this.selectedSession === -1;
        this.initMatTableData(this.reporteAsistenciasSessions.participantes);
        // if response already has grades, show grades column
        this.toggleGradesColumn(this.getOgAttendantsHaveGrades);
        this.gradesTouched = false;
        this.isAssistanceLoading = false;
        this.errorOnGetAttendance = false;
      },
      error: () => {
        this.reporteAsistenciasSessions = null;
        this.gradesTouched = false;
        this.isAssistanceLoading = false;
        this.errorOnGetAttendance = true;
      },
    });
  }
  //unused
  loadAttendances(value: any) {
    this.sessionsService.getAttendances(value).subscribe(response => {
      const inputData = response.data;
      this.attendancesList = inputData.participantes;
      this.dataSource = new MatTableDataSource<any>(this.attendancesList);
      this.dataSource.paginator = this.paginatorSet;
      this.dataSource.sort = this.sort;
    });
  }

  private initMatTableData(attendants: IAttendant[]) {
    this.dataSource = new MatTableDataSource<IAttendant>(attendants);
    this.dataSource.sort = this.sort;
  }

  onCancelOrShowGradesEdit() {
    if (!this.reporteAsistenciasSessions) {
      return;
    }
    if (this.gradesTouched) {
      // on cancel, return attendants to its original state
      this.reporteAsistenciasSessions.participantes = this.unAlteredAttendants;
      this.initMatTableData(this.unAlteredAttendants);
    }
    this.gradesTouched = false;
    if (!this.getOgAttendantsHaveGrades) {
      this.toggleGradesColumn(!this.showGradeColumn);
    }
  }

  private toggleGradesColumn(showGradeColumn: boolean) {
    this.showGradeColumn = showGradeColumn;
    if (this.showGradeColumn && !this.displayedColumns.includes("grades")) {
      // Inserta la columna "grades" en la antepenúltima posición
      const antePenultimateIndex = this.displayedColumns.length - 2;
      this.displayedColumns.splice(antePenultimateIndex, 0, "grades");
    } else if (!this.showGradeColumn) {
      // Elimina la columna "grades" si ya existe en la lista
      const gradeIndex = this.displayedColumns.indexOf("grades");
      if (gradeIndex !== -1) {
        this.displayedColumns.splice(gradeIndex, 1);
      }
    }
  }

  onUpdateSingleGrade(attendant: IAttendant) {
    attendant.calificacion = attendant.calificacion
      ? Math.round(attendant.calificacion)
      : attendant.calificacion;
    if (attendant.calificacion && attendant.calificacion > 100) {
      attendant.calificacion = 100;
    } else if (attendant.calificacion && attendant.calificacion < 0) {
      attendant.calificacion = 0;
    }
    this.gradesTouched = true;
  }

  registerGrades() {
    if (!this.reporteAsistenciasSessions || !this.gradesTouched) {
      return;
    }
    this.isLoadingGrades = true;
    const setGradesBody: ISetGradeObj[] =
      this.reporteAsistenciasSessions.participantes
        .filter(
          attendant =>
            attendant.calificacion !== undefined &&
            attendant.calificacion !== null
        )
        .map(({ ids, calificacion }) => ({ ids, calificacion: calificacion! }));

    this.sessionsService.registerAttendantsGrades(setGradesBody).subscribe({
      next: () => {
        this.sharedModalService
          .openModal("success-modal", {
            title: "¡Éxito!",
            body: "Se han guardado las calificaciones, recuerda integrar las asistencias a GBU",
          })
          .then(() => {
            this.isLoadingGrades = false;
            this.loadReport();
          });
      },
      error: err => {
        const personalizedError = err.error as ResponseDataInterfaces<null>;
        let msg = `Error al procesar la solicitud, Inténtalo mas tarde.`;
        if (
          err.status === 422 &&
          Number(personalizedError.statusCode) === 422
        ) {
          msg = personalizedError.message;
        }
        this.sharedModalService
          .openModal("error-modal", {
            title: "¡Error!",
            body: msg,
          })
          .then(() => {
            this.isLoadingGrades = false;
          });
      },
    });
  }

  getStatusInfoByNumber(statusId: EnumAssistanceStatus) {
    switch (statusId) {
      case EnumAssistanceStatus.completeInfo:
        return "Completo - no integrado";
      case EnumAssistanceStatus.incompleteInfo:
        return "Incompleto - no integrado";
      case EnumAssistanceStatus.integrated:
        return "Integrado en GB University";
      default:
        return "";
    }
  }

  isAttendanceIntegrated(statusId: EnumAssistanceStatus) {
    return statusId === EnumAssistanceStatus.integrated;
  }

  isAttendanceDetailsBtnDisabled(attendant: IAttendant) {
    return (
      !this.showsAllSessionsAttendance ||
      this.gettingAttendantDetails?.idAsistencia === attendant.idAsistencia
    );
  }

  isDeleteAttendantBtnDisabled(attendant: IAttendant) {
    return (
      this.isAttendanceIntegrated(attendant.idSesionAsistenciaEstatus) ||
      !this.showsAllSessionsAttendance ||
      this.deletingAttendant === attendant.idAsistencia
    );
  }
  async onDeleteAttendant(attendant: IAttendant) {
    if (this.isAttendanceIntegrated(attendant.idSesionAsistenciaEstatus)) {
      return;
    }
    const personalConfirmationMsg = attendant.nombre
      ? `de  ${attendant.nombre} ${attendant.apellidoPaterno}`
      : "";
    const confirmation = await this.sharedModalService.openModal(
      "confirm-modal",
      {
        title: "Confirmar acción",
        body: `¿Estás seguro de que deseas eliminar la asistencia ${personalConfirmationMsg}? Se eliminará de todas las partes de la sesión.`,
      }
    );
    if (!confirmation) {
      return;
    }
    this.deletingAttendant = attendant.idAsistencia;
    this.assistanceService.deleteAttendance(attendant.ids).subscribe({
      next: () => {
        this.sharedModalService
          .openModal("success-modal", {
            title: "¡Éxito!",
            body: "Asistencia eliminada con éxito",
          })
          .then(() => {
            // loader end and reload data
            this.deletingAttendant = null;
            this.loadReport();
          });
      },
      error: () => {
        this.sharedModalService
          .openModal("error-modal", {
            title: "Error!",
            body: "Ha ocurrido un error al eliminar la asistencia",
          })
          .then(() => {
            // loader end
            this.deletingAttendant = null;
          });
      },
    });
  }

  /*filterChange(data: Event) {
    const value = (data.target as HTMLInputElement).value;
    this.dataSource.filter = value;
  }*/

  filterChange(data: Event) {
    this.searchText = (data.target as HTMLInputElement).value;

    this.currentPage = 1;

    this.loadReport();
  }

  onBlurCourseSelect() {
    if (!this.selectedCourseSession) {
      this.showSelectCourseError = true;
    } else {
      this.showSelectCourseError = false;
    }
  }

  generarReporte() {
    if (!this.reporteAsistenciasSessions || !this.selectedCourseSession) {
      return;
    }

    this.sessionsService
      .getReporteAsistenciaSession(
        this.selectedCourseSession.Id,
        this.selectedSession === -1 ? undefined : this.selectedSession,
        1,
        this.totalRecords
      )
      .subscribe(response => {

        const totalPartes = response.numeroTotalPartesSesion;
    const totalParticipantes =
      response.participantes.length;

    // HEADER
    const header = [
      [
        `Reporte de asistencia - ${
          this.selectedCourseSession?.nombreEvento ?? "-"
        }`,
      ],
      [
        `Descripción: ${
        response.descripcion?.trim()
            ? response.descripcion
            : "Sin descripción"
        }`,
      ],
      [
        `Inicio: ${response.fechaInicioSesion ?? "-"}`,
        [],
        [],
        [],
        "",
        `Participantes: ${totalParticipantes}`,
      ],
      [`Término: ${response.fechaFinSesion ?? "-"}`],
      [],
    ];

    const assistanceProcessedData =
      response.participantes.map(participante => {
        const historial = participante.calificacionHistorial ?? [];
        const attendancePerPart: Record<string, string> = {};

        if (
          this.showsAllSessionsAttendance &&
          participante.fechasInicioSesion
        ) {
          // initialize all parts empty
          for (let i = 1; i <= totalPartes; i++) {
            attendancePerPart[`Asistencia ${i}`] = "";
          }

          // fill parts with real data
          participante.fechasInicioSesion.forEach(sesion => {
            const attendanceDateString = sesion.fechaRegistro
              ? formatDate(sesion.fechaRegistro, "dd/MM/yyyy", "es-MX")
              : "";
            attendancePerPart[`Asistencia ${sesion.parte}`] =
              attendanceDateString;
          });
        } else {
          // if only one part is selected use fechaRegistro
          const fechaRegistro = participante.fechaRegistro
            ? formatDate(participante.fechaRegistro, "dd/MM/yyyy", "es-MX")
            : "";
          attendancePerPart[`Asistencia ${this.selectedSession}`] =
            fechaRegistro;
        }

        const calificaciones: Record<string, any> = {};

        if (historial.length > 0) {
          historial.forEach((c, index) => {
            calificaciones[`Calificación ${index + 1}`] = c.calificacion;
          });
        } else {
          calificaciones["Calificación 1"] = participante.calificacion ?? "";
        }
        return {
          ID: participante.numeroPersona,
          Nombre: `${this.getFullName(participante, true)} `,
          Correo: participante.email,
          CURP: participante.curp,

          "Unidad organizacional": participante.unidadOrganizacional?.trim()
            ? participante.unidadOrganizacional
            : "Sin información",

          "Partes asistidas": `${
            this.selectedCourseSession?.QrMeastro
              ? totalPartes
              : participante.numeroSesion
          } de ${totalPartes}`,

          ...attendancePerPart,
          ...calificaciones,

          Estatus: this.getStatusInfoByNumber(
            participante.idSesionAsistenciaEstatus
          ),
        };
      });

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(header);
    XLSX.utils.sheet_add_json(ws, assistanceProcessedData, {
      origin: "A6",
    });

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Datos");

        XLSX.writeFile(wb, `asistencia-${this.selectedCourseSession?.titulo}.xlsx`);
      });
  }

  viewDetailsSession() {
    this.Openpopup(SesionDetailsComponent);
  }

  Openpopup(component: any) {
    const _popup = this.dialog.open(component, {
      width: "60%",
      enterAnimationDuration: "200ms",
      exitAnimationDuration: "200ms",
      data: {
        infoPopup: this.selectedCourseSession,
      },
    });
    _popup.afterClosed().subscribe(item => {});
  }

  // offcanvas
  openOffcanvas(attendant: IAttendant) {
    this.gettingAttendantDetails = attendant;
    this.offcanvasComponent.open();
  }

  // duplicate attendance modal
  async openDuplicateAttendanceModal() {
    if (
      !this.selectedCourseSession ||
      !this.selectedYear ||
      !this.reporteAsistenciasSessions
    ) {
      return;
    }
    this.isDuplicateAttendanceModalOpen = true;
    await this.duplicateAttendanceModal.open();
  }

  onConfirmDuplicateAttendance(targetSession: ICourseSession): void {
    if (!this.selectedCourseSession) {
      return;
    }
    this.duplicateAttendanceModal.close();

    this.isLoadingDuplicateAttendance = true;
    this.assistanceService
      .postDuplicateAttendanceToOtherSession({
        sessionId: this.selectedCourseSession.Id,
        newSessionId: targetSession.Id,
      })
      .subscribe({
        next: ({ duplicatedAttendances, notDuplicatedAttendances }) => {
          let msg = `Se duplicaron ${duplicatedAttendances} asistencias correctamente.`;

          if (notDuplicatedAttendances > 0) {
            msg += ` (${notDuplicatedAttendances} omitidas debido a que ya se encontraban registradas en la sesión destino)`;
          }

          this.sharedModalService
            .openModal("success-modal", {
              title: "¡Éxito!",
              body: msg,
            })
            .then(() => {
              this.isLoadingDuplicateAttendance = false;
            });
        },
        error: err => {
          const personalizedError = err.error as ResponseDataInterfaces<null>;
          let msg = `Error al procesar la solicitud, Inténtalo mas tarde.`;
          if (
            err.status === 422 &&
            Number(personalizedError.statusCode) === 422
          ) {
            msg = personalizedError.message;
          }
          this.sharedModalService
            .openModal("error-modal", {
              title: "¡Error!",
              body: msg,
            })
            .then(() => {
              this.isLoadingDuplicateAttendance = false;
            });
        },
      });
  }

  // modal
  async onCloseModal($event: boolean) {
    await this.modalComponent.close();
    this.isModalOpen = false;
    if ($event) {
      this.loadReport();
    }
  }

  // attendanceModal

  openAttendanceModal(modal: TemplateRef<void>) {
    this.modalRef = this.modal.open(modal, {
      size: "lg",
      centered: true,
      backdrop: "static",
    });
  }

  validateDataAndAddAttendant({
    type,
    value,
  }: {
    type: originDataEnumEmailPerAd;
    value: string;
  }) {
    this.assistanceService.addGuestAttendee(
      { type, value },
      {
        mode: "self",
        fkIdSesion: Number(this.selectedCourseSession?.Id),
        numeroSesion: Number(this.selectedSession),
        onSuccessFound: this.onSuccessAddAttendance,
        onSuccessNotFound: this.onSuccessAddAttendance,
      }
    );
  }

  onSuccessAddAttendance = () => {
    this.closeAttendanceModal();
    this.sharedModalService
      .openModal("success-modal", {
        title: "¡Éxito!",
        body: "Asistencia agregada con éxito",
      })
      .then(() => {
        this.loadReport();
      });
  };

  closeAttendanceModal() {
    this.modalRef?.close();
  }

  // duplicates modal
  async openDuplicatesModal() {
    if (
      !this.selectedCourseSession ||
      !this.selectedYear ||
      !this.reporteAsistenciasSessions
    ) {
      return;
    }
    this.modalConfig.modalTitle = `${this.basicModalTitle} - ${this.selectedCourseSession.nombreEvento} - ${this.selectedCourseSession.titulo}`;
    this.isModalOpen = true;
    await this.modalComponent.open();
  }

  sortData(sort: Sort) {
    if (!this.reporteAsistenciasSessions) {
      return;
    }
    const sortedData = this.reporteAsistenciasSessions.participantes.slice();

    if (!sort.active || sort.direction === "") {
      this.dataSource = new MatTableDataSource<IAttendant>(sortedData);
      this.dataSource.paginator = this.paginatorSet;
      this.dataSource.sort = this.sort;
      return;
    }

    // Use sort directly on the data array without assigning its return value
    sortedData.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "code":
          return this.compare(a.numeroPersona, b.numeroPersona, isAsc);
        case "curp":
          return this.compare(a.curp, b.curp, isAsc);
        case "name":
          return this.compare(
            `${a.nombre} ${a.apellidoPaterno} ${a.apellidoPaterno}`,
            `${b.nombre} ${b.apellidoPaterno} ${b.apellidoPaterno}`,
            isAsc
          );
        case "email":
          return this.compare(a.email, b.email, isAsc);
        case "numeroSesion":
          return this.compare(a.numeroSesion, b.numeroSesion, isAsc);
        case "status":
          return this.compare(
            a.idSesionAsistenciaEstatus,
            b.idSesionAsistenciaEstatus,
            isAsc
          );
        case "date":
          return this.compare(a.fechaRegistro, b.fechaRegistro, isAsc);
        case "grades":
          return this.compare(a.calificacion, b.calificacion, isAsc);
        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource<IAttendant>(sortedData);
    this.dataSource.paginator = this.paginatorSet;
    this.dataSource.sort = this.sort;
  }

  // Función de comparación genérica
  private compare(a: any, b: any, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  onPageSizeChange(event: PageEvent) {
    this.selectedPageSize = event.pageSize;
    this.currentPage = event.pageIndex + 1;
    this.loadReport();
    // this.dataSource.paginator = this.paginatorSet;
  }
  onCloseAttendanceDrawer(shouldRefresh: boolean) {
    this.offcanvasComponent.close();

    if (shouldRefresh) {
      this.loadReport();
    }
  }
}
